export default {"src":"/_next/static/media/facebook.dfe4efb1.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};